import * as React from 'react';
import { View } from 'react-native';
import { createMaterialTopTabNavigator, MaterialTopTabBar } from '@react-navigation/material-top-tabs';

import OrderListIndexScreen from '../screens/order/OrderGroupAll';
import OrderListPendingScreen from '../screens/order/OrderGroupPending';
import FontStyles from '../constants/FontStyle';
import Colors from '../constants/Colors';
import HeaderGradient from '../components/headers/HeaderGradient';
import GenericHeader from '../components/headers/GenericHeader';

const Tab = createMaterialTopTabNavigator();

export default function OrderTabNavigator() {
    return (
        <>
            <GenericHeader
                title={`Invoices`}
            />
            
            <Tab.Navigator
                tabBar={props => <HeaderGradient noPadding>
                    <MaterialTopTabBar {...props} />
                </HeaderGradient>}
                tabBarOptions={{
                    labelStyle: {
                        letterSpacing: 0.4,
                        ...FontStyles.size14,
                        ...FontStyles.lh16,
                        ...FontStyles.medium,
                        textAlign: 'center',
                        marginBottom: 8,
                        textTransform: 'capitalize'
                    },
                    activeTintColor: '#FFFFFF',
                    indicatorStyle: { height: 3, backgroundColor: '#FFFFFF' },
                    style: { backgroundColor: 'transparent', elevation: 0, },
                }}
            >
                <Tab.Screen
                    name="All"
                    component={OrderListIndexScreen}
                    options={{
                        title: 'All Orders - Suplias Now',
                        tabBarLabel: 'All'
                    }}
                />
                <Tab.Screen
                    name="Pending"
                    component={OrderListPendingScreen}
                    options={{
                        title: 'Pending Orders - Suplias Now',
                        tabBarLabel: 'Pending'
                    }}
                />
            </Tab.Navigator>
        </>
    );
}
